<template>
  <LoadingSpinner v-if="!isReadyPrint" :message="'Đang tải dữ liệu in ...'" />
  <div v-else>
    <b-row>
      <b-col class="d-flex align-items-center">
        <img
          :src="SUPPLIER_INFO.logo"
          alt="Logo"
          style="height: 80px; width: auto; margin-right: 10px; object-fit: contain"
        />
        <div>
          <p class="label-color font-size-print m-0 font-weight-bold">
            {{ SUPPLIER_INFO.companyName }}
          </p>
          <p class="label-color font-size-print m-0">
            Địa chỉ: {{ SUPPLIER_INFO.address }}
          </p>
          <p class="label-color font-size-print m-0">
            MST: {{ SUPPLIER_INFO.taxCode }} 
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-10">
      <div class="print-content-wrapper" style="margin-left: 20px; margin-right: 20px; width: 100%">
        <h5 class="label-color text-center print-bb-title mb-4">
          BIÊN BẢN GIAO NHẬN KIÊM PHIẾU XUẤT KHO
        </h5>
        <div class="d-flex justify-content-between align-items-start mb-4">
          <div>
            <p class="label-color font-size-print m-0">
              Số hóa đơn: {{ bill.einvoice && bill.einvoice.invoiceNo ? String(bill.einvoice.invoiceNo).trim() : '' }}
            </p>
            <p class="label-color font-size-print m-0">
              ID hoá đơn: {{ String(bill.billNumber || '').trim() }}
            </p>
          </div>
          <p class="label-color font-size-print font-weight-bold m-0">{{ formattedCreatedDate }}</p>
        </div>
        <p class="m-0 font-size-print mb-4">
          Hôm nay, chúng tôi gồm:
        </p>

        <div class="mb-4">
          <p class="m-0 label-color font-size-print mb-2">
            <strong>BÊN GIAO(A): {{ SUPPLIER_INFO.companyName }}</strong>
          </p>
          <p class="m-0 font-size-print">
            <span class="font-weight-bold">Địa chỉ: </span>
            <span class="font-weight-bold">{{
              bill.supplierAddress || SUPPLIER_INFO.address
            }}</span>
          </p>
          <b-row class="align-items-center">
            <b-col cols="3">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">Mã số thuế: </span> <span class="font-weight-bold">{{ SUPPLIER_INFO.taxCode }}</span></span
              >
            </b-col>
            <b-col cols="2">
              <span class="m-0 font-size-print"><span class="font-weight-bold">ĐT:</span> ....................</span>
            </b-col>
          </b-row>
          <b-row class="align-items-center">
            <b-col cols="3">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">Đại diện: </span> Ông/Bà: ....................</span
              >
            </b-col>
            <b-col cols="3">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">Chức vụ: </span> ....................</span
              >
            </b-col>
          </b-row>
          <p class="m-0 font-size-print mb-3">
            Làm đại diện cho bên Giao hàng hóa sau đây,
            <strong>gọi là bên A</strong>
          </p>
        </div>

        <div class="mb-4">
          <p class="m-0 label-color font-size-print mb-2">
            <strong
              >BÊN NHẬN(B):
              {{ bill.customerCompanyName || bill.customerName }}</strong
            >
          </p>
          <p class="m-0 font-size-print">
            <span class="font-weight-bold">Địa chỉ: </span>
            <span class="font-weight-bold">{{
              bill.customerBillAddress || bill.customerAddress
            }}</span>
          </p>
          <b-row class="align-items-center">
            <b-col cols="3">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">Mã số thuế: </span>
                <span
                  v-if="(bill.customerTaxCode || '').trim()"
                  class="font-weight-bold"
                  >{{ (bill.customerTaxCode || '').trim() }}</span
                >
                <span v-else class="font-weight-bold">....................</span></span
              >
            </b-col>
            <b-col cols="2">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">ĐT: </span>
                <span
                  v-if="(bill.customerPhone || '').trim()"
                  class="font-weight-bold"
                  >{{ (bill.customerPhone || '').trim() }}</span
                >
                <span v-else class="font-weight-bold">....................</span></span
              >
            </b-col>
          </b-row>
          <b-row class="align-items-center">
            <b-col cols="3">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">Người nhận hàng:</span>
                <span
                  v-if="(bill.receiverName || '').trim()"
                  class="font-weight-bold"
                  >{{ (bill.receiverName || '').trim() }}</span
                >
                <span v-else class="font-weight-bold">...........................................</span></span
              >
            </b-col>
            <b-col cols="2">
              <span class="m-0 font-size-print"
                ><span class="font-weight-bold">ĐT: </span>
                <span
                  v-if="(bill.receiverMobile || '').trim()"
                  class="font-weight-bold"
                  >{{ (bill.receiverMobile || '').trim() }}</span
                >
                <span v-else class="font-weight-bold">....................</span></span
              >
            </b-col>
          </b-row>
            <p class="m-0 font-size-print">
            <span class="font-weight-bold">Địa chỉ giao hàng: </span>
            <span class="font-weight-bold">{{ bill.receiverAddress || '......................................................................................................' }}</span>
          </p>
          <p class="m-0 font-size-print mb-3">
            Làm đại diện cho bên Nhận hàng hóa sau đây,
            <strong>gọi là bên B</strong>
          </p>
        </div>

        <p class="m-0 font-size-print mb-4">
          1. Bên A đã giao đủ hàng hóa dưới đây cho bên B:
        </p>

        <table class="table table-bordered-print col-md-12 mb-10" style="table-layout: fixed; width: 100%">
          <colgroup>
            <col style="width: 6%" />
            <col style="width: 80%" />
            <col style="width: 7%" />
            <col style="width: 7%" />
          </colgroup>
          <tr>
            <th class="label-color text-center font-size-print" width="6%" style="width: 6%">STT</th>
            <th class="label-color font-size-print" width="80%" style="width: 80%">TÊN HÀNG HÓA</th>
            <th class="label-color text-center font-size-print" width="7%" style="width: 7%">ĐVT</th>
            <th class="label-color text-center font-size-print" width="7%" style="width: 7%">SL</th>
          </tr>
          <template v-for="(item, index) in bill.listBillItem">
            <tr :key="'item-' + index">
              <td class="text-center align-middle">
                <p class="m-0 font-size-print" v-if="item.billItemType === BILL_ITEM_TYPE_PRODUCT">
                  {{ item.stt }}
                </p>
              </td>
              <td class="align-middle">
                <p
                  v-show="
                    item.type === PRODUCT_TYPE.PRODUCT ||
                    item.type === PRODUCT_TYPE.PRODUCT_IMEI ||
                    item.type === PRODUCT_TYPE.PRODUCT_SERVICE
                  "
                  class="m-0 font-size-print"
                  v-if="item.billItemType === BILL_ITEM_TYPE_PRODUCT"
                >
                  {{ item.name }}
                </p>
                <p
                  v-show="
                    item.type === PRODUCT_TYPE.PRODUCT ||
                    item.type === PRODUCT_TYPE.PRODUCT_IMEI ||
                    item.type === PRODUCT_TYPE.PRODUCT_SERVICE
                  "
                  class="ml-0 font-size-gift"
                  v-else-if="item.billItemType === BILL_ITEM_TYPE_PRODUCT_BONUS"
                >
                  <i style="color: rgb(24, 28, 50)" class="fas fa-gift ml-4"></i>
                  {{ item.name }}
                </p>
                <p
                  v-show="
                    item.type === PRODUCT_TYPE.PRODUCT ||
                    item.type === PRODUCT_TYPE.PRODUCT_IMEI ||
                    item.type === PRODUCT_TYPE.PRODUCT_SERVICE
                  "
                  class="ml-0"
                  v-else-if="
                    item.billItemType === BILL_ITEM_TYPE_PRODUCT_PROMOTION
                  "
                >
                  <i style="color: rgb(24, 28, 50)" class="fas fa-tags ml-4"></i>
                  {{ item.name }}
                </p>
                <div
                  class="table-responsive"
                  v-show="
                    item.comboItems !== undefined && item.comboItems.length > 0
                  "
                >
                  <table>
                    <tr>
                      <td style="border: none">
                        <p class="m-0 font-size-print">
                          {{ item.name }}
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-for="(items, i) in item.comboItems"
                      :key="i"
                      style="border-top: 1px solid gray"
                    >
                      <td
                        style="border: none; width: -webkit-fill-available"
                        class="font-size-gift"
                      >
                        <i style="color: rgb(24, 28, 50)" class="fas fa-cube"></i>
                        {{ items.productName }}
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td
                class="text-center align-middle font-size-print"
                :rowspan="item.imeiCodes ? 2 : 1"
              >
                <p
                  class="m-0 print-uom"
                  v-if="
                    item.billItemType === BILL_ITEM_TYPE_PRODUCT ||
                    item.billItemType === BILL_ITEM_TYPE_PRODUCT_PROMOTION
                  "
                >
                  {{ item.productUnit || 'Cái' }}
                </p>
              </td>
              <td
                class="text-center align-middle font-size-print"
                :rowspan="item.imeiCodes ? 2 : 1"
              >
                <p class="m-0 print-qty">{{ item.quantity }}</p>
              </td>
            </tr>
            <tr v-if="item.imeiCodes" :key="'imei-' + index">
              <td colspan="2" class="font-size-print imei-cell" style="padding: 4px 8px; border-top: none">
                <p class="m-0">{{ item.imeiCodes }}</p>
              </td>
            </tr>
          </template>
          <tr>
            <td class="text-center align-middle font-size-print" :colspan="3">
              <p class="label-color font-weight-bold m-0">TỔNG CỘNG</p>
            </td>
            <td class="text-center align-middle font-size-print">
              <p class="font-weight-bold m-0">{{ bill.sumQuantity }}</p>
            </td>
          </tr>
        </table>

        <div class="mb-4">
          <p class="m-0 font-size-print">
            2. Các hàng hóa nêu trên đều được Bên A cung cấp đầy đủ hóa đơn bán hàng.
          </p>
          <p class="m-0 font-size-print">
            3. Tình trạng hàng hóa khi bàn giao: <strong>Mới 100%</strong>
          </p>
          <p class="m-0 font-size-print">
            4. Bên mua cần kiểm tra, đối chiếu IMEI/Serial khi nhận hàng. Các khiếu nại về thông tin hàng hóa, số lượng, imei vui lòng phản hồi <strong>trong vòng 24h</strong> kể từ thời điểm giao hàng.
          </p>
          <p class="m-0 font-size-print">
            5. Biên bản lập thành <strong>02 bản</strong>, có giá trị pháp lý như nhau, mỗi bên giữ 01 bản.
          </p>
        </div>

        <p class="m-0 font-size-print text-center mt-4 mb-4">
          Xin chân thành cảm ơn Quý khách hàng!
        </p>

        <div class="signature-section">
          <b-row class="no-gutters">
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print"
                  >ĐẠI DIỆN BÊN NHẬN</span
                >
              </p>
              <p class="mb-0 font-size-print">(Ký ghi rõ họ tên)</p>
            </b-col>
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print"
                  >ĐẠI DIỆN BÊN GIAO</span
                >
              </p>
              <p class="mb-0 font-size-print">(Ký ghi rõ họ tên)</p>
            </b-col>
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print"
                  >ĐƠN VỊ VẬN CHUYỂN</span
                >
              </p>
              <p class="mb-0 font-size-print">(Ký ghi rõ họ tên)</p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script>
import { convertPrice, formatDate, cloneDeep } from '@/utils/common';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import { BILL_ITEM_TYPE, PRODUCT_TYPE, AMOUNT_TYPE } from '@/utils/enum';
import { SUPPLIER_INFO } from '@/utils/constants';

export default {
  props: ['printData'],
  watch: {
    printData: {
      async handler(newPrintData) {
        if (!newPrintData?.bill) return;
        const billCopy = cloneDeep(newPrintData.bill);
        billCopy.listBillItem = this.groupBillItemByProductIdAndPrice(
          billCopy.listBillItem || [],
        );
        this.bill = billCopy;
        await this.$nextTick();
        setTimeout(() => {
          this.isReadyPrint = true;
        }, 1000);
      },
      deep: false,
      immediate: true,
    },
  },
  computed: {
    formattedCreatedDate() {
      if (!this.bill?.createdAt) return '';
      const date = this.bill.createdAt.split(' ')[1];
      const [day, month, year] = date.split('/');
      return `Ngày ${day} tháng ${month} năm ${year}`;
    },
  },
  methods: {
    convertPrice,
    formatDate,
    groupBillItemByProductIdAndPrice(listBillItems) {
      const result = [];
      const keyMap = {};
      let stt = 0;

      for (const item of listBillItems) {
        if (item.billItemType !== BILL_ITEM_TYPE.PRODUCT) {
          result.push({ ...item });
          continue;
        }

        const key = `${item.id}_${item.price}`;
        if (keyMap[key] !== undefined) {
          const existing = result[keyMap[key]];
          existing.quantity += item.quantity;
          if (item.imeiCode) {
            existing.imeiCodes = [existing.imeiCodes, item.imeiCode].filter(Boolean).join(', ');
          }
          continue;
        }

        stt += 1;
        keyMap[key] = result.length;
        result.push({
          ...item,
          productId: item.id,
          stt,
          imeiCodes: item.imeiCode || '',
          quantity: item.quantity,
        });
      }

      return result;
    },
  },
  data() {
    return {
      BILL_ITEM_TYPE_PRODUCT: BILL_ITEM_TYPE.PRODUCT,
      BILL_ITEM_TYPE_PRODUCT_BONUS: BILL_ITEM_TYPE.PRODUCT_BONUS,
      BILL_ITEM_TYPE_PRODUCT_PROMOTION: BILL_ITEM_TYPE.PRODUCT_PROMTION,
      AMOUNT_TYPE_MONEY: AMOUNT_TYPE.MONEY,
      AMOUNT_TYPE_PERCENT: AMOUNT_TYPE.PERCENT,
      PRODUCT_TYPE,
      SUPPLIER_INFO,
      bill: {},
      isReadyPrint: false,
    };
  },
  components: {
    LoadingSpinner,
  },
};
</script>
<style scoped>
.label-color {
  color: black;
  font-weight: 600;
}

.content-info {
  color: black;
  font-weight: 500;
}

.table-bordered-print th {
  border: 0.5px solid #474545;
}

.table-bordered-print td {
  border: 0.5px solid #474545;
}

.print-bb-title {
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.font-size-print {
  color: black;
  font-size: 11px;
}

.font-size-warranty {
  color: black;
  font-size: 11px;
}

.content-product {
  line-height: 1.375;
  white-space: pre-wrap;
  font-size: 11px;
  margin-top: 4px;
}

.font-size-gift {
  color: black;
  font-size: 10px;
}

.imei-cell p {
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}
</style>
